__turbopack_context__.v({
  "heading": "FolderHeaderTitle-module__ZdGHUW__heading",
  "icon": "FolderHeaderTitle-module__ZdGHUW__icon",
  "skeletonWrapper": "FolderHeaderTitle-module__ZdGHUW__skeletonWrapper",
  "titleWrapper": "FolderHeaderTitle-module__ZdGHUW__titleWrapper",
});
